import React, { useState, useEffect, useRef } from 'react'
import { Pagination, Spin, message, Button, DatePicker } from 'antd'
import UseDebounce from '../../users/helpers/UseDebounce'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import SearchField from '../../home/components/filters/SearchField'
import BasketStatisticsTable from './BasketStatisticsTable'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { getListItemsAddToBasket, exportListItemsAddToBasket } from '../../../services/api/3dApi'
import moment from 'moment'
import axios from 'axios'

const {RangePicker} = DatePicker

function StatisticsAddBasketPage() {
    const [listBasket, setListBasket] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(10)
    const [barcode, setBarcode] = useState('')
    const [user, setUser] = useState('')
    const [createAt, setCreateAt] = useState([moment().subtract(1, 'month').startOf('day'), moment().endOf('day') ])
    const [payloadCreateAt, setPayloadCreateAt] = useState({
        from: moment().subtract(1, 'month').startOf('day').format('DD/MM/YYYY HH:mm'),
        to: moment().endOf('day').format('DD/MM/YYYY HH:mm')
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const cancelSourceRef = useRef(null)

    const debounceBarcode = barcode === '' ? UseDebounce(barcode, 0) : UseDebounce(barcode, 500)
    const debounceUser = user === '' ? UseDebounce(user, 0) : UseDebounce(user, 500)

    const fetchBasket = async () => {
        // Hủy request cũ nếu vẫn đang chạy
        if (cancelSourceRef.current) {
            // console.log('Hủy request cũ')
            cancelSourceRef.current.cancel('Request bị hủy trước đó')
            await Promise.resolve()
        }

        // // Tạo token mới
        cancelSourceRef.current = axios.CancelToken.source()
        
        setLoading(true)
        setError('')
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (!!barcode) payload.order = barcode
            if (!!user) payload.user = user
            if (!!Object.keys(payloadCreateAt).length) {
                if (payloadCreateAt.from) payload['date[from]'] = payloadCreateAt.from
                if (payloadCreateAt.to) payload['date[to]'] = payloadCreateAt.to
            }

            const { data: res } = await getListItemsAddToBasket(payload, cancelSourceRef.current.token)
            const { data, success, error } = { ...res }
            if (success) {
                setTotal(data.total)
                setListBasket(data.items || [])
            } else {
                setError(error)
                setListBasket([])
                message.error(error)
            }

            setLoading(false)
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request bị hủy')
            } else {
                setError(error.message)
                message.error(error.message)
                setLoading(false)
            }
        }
    }

    const handleChangeBarcode = (field, value) => {
        setBarcode(value)
        setPage(1)
    }

    const handleChangeUser = (field, value) => {
        setUser(value)
        setPage(1)
    }

    const handleChangeCreateAt = (field, value) => {
        
        setCreateAt(value)
        setPage(1)
    }

    const handleChangeCreateAtNew = (dates) => {
        if (!!dates && dates.length === 2) {
            const date_from = moment(dates[0]).format('DD/MM/YYYY HH:mm')
            const date_to = moment(dates[1]).format('DD/MM/YYYY HH:mm')

            
            setCreateAt(dates)
            setPayloadCreateAt({
                from: date_from,
                to: date_to
            })
        } else {
            setCreateAt([moment().subtract(1, 'month').startOf('day'), moment().endOf('day') ])
            setPayloadCreateAt({
                from: moment().subtract(1, 'month').startOf('day').format('DD/MM/YYYY HH:mm'),
                to: moment().endOf('day').format('DD/MM/YYYY HH:mm')
            })
        }

        setPage(1)
    }

    const exportBasket = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (!!barcode) payload.order = barcode
            if (!!user) payload.user = user
            if (!!Object.keys(payloadCreateAt).length) {
                if (payloadCreateAt.from) payload['date[from]'] = payloadCreateAt.from
                if (payloadCreateAt.to) payload['date[to]'] = payloadCreateAt.to
            }
            const { data } = await exportListItemsAddToBasket(payload)

            if (data) {
                downloadFileFromData(data, { filename: `basket-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchBasket()
    }, [debounceBarcode, debounceUser, page, limit, createAt])

    return (
        <div className='StatisticsAddBasketPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mt-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h3>Thống kê thêm giỏ</h3>
                            <div className="listBtn">
                                <Button
                                    className='ant-btn ant-btn-primary mr-3'
                                    onClick={exportBasket}
                                    // disabled={loading}
                                >
                                    Export
                                </Button>
                                <a className="ant-btn mr-3 ant-btn-secondary" href="/statistics-delete-basket">Thống kê xóa giỏ</a>
                                <a className="ant-btn ant-btn-secondary mr-3" href="/statistics-uncomplete-basket">Thống kê giỏ chưa hoàn thành</a>
                                <a className="ant-btn ant-btn-secondary" href="/baskets">Baskets</a>
                            </div>
                        </div>
                        <div className='jumbotron p-3 mb-3'>
                            <div className='row align-items-end'>
                                <div className='col-12 col-xl-auto'>
                                    <label className='mb-1 font-weight-bold'>Mã đơn/Mã item</label>
                                    <SearchField
                                        field='order_number'
                                        onChangeInput={handleChangeBarcode}
                                        // disabled={loading}
                                        placeholder='Tìm theo barcode...' />
                                </div>
                                <div className='col-12 col-xl-auto'>
                                    <label className='mb-1 font-weight-bold'>Người thêm</label>
                                    <SearchField field='basket_number'
                                        onChangeInput={handleChangeUser}
                                        // disabled={loading}
                                        placeholder='Tìm theo người thêm...' />
                                </div>
                                <div className='col-12 col-xl-2'>
                                    <label className='mb-1 font-weight-bold'>Thời gian thêm</label>
                                    {/* <FilterDateRangeV2
                                        field='add_time'
                                        onDatesChange={handleChangeCreateAt}
                                        showTime={true}
                                        disabled={loading}
                                    /> */}

                                    <RangePicker
                                        ranges={{
                                            'Today': [moment(), moment()],
                                            'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                        }}
                                        format='DD/MM/YYYY HH:mm'
                                        showTime={{
                                            hideDisabledOptions: true,
                                            format: 'HH:mm',
                                            defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
                                        }}
                                        onChange={handleChangeCreateAtNew}
                                        // disabled={disabled || false}
                                        value={createAt}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && <div className='text-danger'>{error}</div>}
                            </div>
                            <Pagination current={page} total={total} pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                    </div>}
                                onChange={handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['3', '10', '20', '50', '100']}
                                onShowSizeChange={handleShowSizeChange}
                            />
                        </div>
                        <Spin spinning={loading} tip='Loading...'>
                            <BasketStatisticsTable
                                listBasket={listBasket}
                                tableType='tableAdd'
                            />
                        </Spin>
                        <Pagination current={page} total={total} pageSize={limit}
                            onChange={handlePageChange}
                            showQuickJumper
                            className='text-right' showSizeChanger
                            pageSizeOptions={['3', '10', '20', '50', '100']}
                            onShowSizeChange={handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticsAddBasketPage